import React from "react";
import useStyles from "./styles";
import { Footer } from "shared/components";

const MainLayout = ({ children }) => {
  const classes = useStyles();
  return (
    <div className={classes.footerContainer}>
      <div className={classes.content}>
        <div className={classes.content}>{children}</div>
        <div className={classes.footer}>
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default MainLayout;
